<template>
  <div style="padding-right: 30px; margin-top: 10px; margin-bottom: 10px">
    <div>
      <h2 class="title">{{ $t("graeList.national.filteredElements") }}</h2>
      <h3 class="title2">
        {{ $t("graeList.national.singleYearElements") }}
      </h3>
      <table>
        <thead>
          <tr>
            <th>{{ $t("graeList.national.totalAEActive") }}</th>
            <th>{{ $t("graeList.national.totalATEActive") }}</th>
            <th>{{ $t("graeList.national.totalAMEActive") }}</th>
            <th>
              {{ $t("graeList.national.newInscriptions") }}
              {{ anneeScolaireSingleYearInscription }}-{{ anneeScolaireSingleYearInscription }}
            </th>
            <th>
              {{ $t("graeList.national.labelings") }} {{ anneeScolaireSingleYear }}-{{
                anneeScolaireSingleYear
              }}
            </th>
            <th>
              {{ $t("graeList.national.renewals") }} {{ anneeScolaireSingleYear }}-{{
                anneeScolaireSingleYear
              }}
            </th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>
              <a href="#" @click.prevent="redirectToDetails(false, 'totalAEActive', true)">
                <span v-if="isLoading" class="spinner"></span>
                <span v-else>{{ totalAEActive(true) }}</span>
              </a>
            </td>
            <td>
              <a href="#" @click.prevent="redirectToDetails(false, 'totalATEActive', true)">
                <span v-if="isLoading" class="spinner"></span>
                <span v-else>{{ totalATEActive(true) }}</span>
              </a>
            </td>
            <td>
              <a href="#" @click.prevent="redirectToDetails(false, 'totalAMEActive', true)">
                <span v-if="isLoading" class="spinner"></span>
                <span v-else>{{ totalAMEActive(true) }}</span>
              </a>
            </td>
            <td>
              <a href="#" @click.prevent="redirectToDetails(true, 'newInscriptions', true)">
                <span v-if="isLoading" class="spinner"></span>
                <span v-else>{{ newInscriptions(true) }}</span>
              </a>
            </td>
            <td>
              <a href="#" @click.prevent="redirectToDetails(false, 'labelings', true)">
                <span v-if="isLoading" class="spinner"></span>
                <span v-else>{{ labelings(true) }}</span>
              </a>
            </td>
            <td>
              <a href="#" @click.prevent="redirectToDetails(false, 'renewals', true)">
                <span v-if="isLoading" class="spinner"></span>
                <span v-else>{{ renewals(true) }}</span>
              </a>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <div>
      <h3 class="title2">
        {{ $t("graeList.national.schoolYearElements") }}
      </h3>
      <table>
        <thead>
          <tr>
            <th>{{ $t("graeList.national.totalAEActive") }}</th>
            <th>{{ $t("graeList.national.totalATEActive") }}</th>
            <th>{{ $t("graeList.national.totalAMEActive") }}</th>
            <th>
              {{ $t("graeList.national.newInscriptions") }} {{ anneeScolaireSchoolYearInscription }}
            </th>
            <th>{{ $t("graeList.national.labelings") }} {{ anneeScolaireSchoolYear }}</th>
            <th>{{ $t("graeList.national.renewals") }} {{ anneeScolaireSchoolYear }}</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>
              <a href="#" @click.prevent="redirectToDetails(true, 'totalAEActive', false)">
                <span v-if="isLoading" class="spinner"></span>
                <span v-else>{{ totalAEActive(false) }}</span>
              </a>
            </td>
            <td>
              <a href="#" @click.prevent="redirectToDetails(true, 'totalATEActive', false)">
                <span v-if="isLoading" class="spinner"></span>
                <span v-else>{{ totalATEActive(false) }}</span>
              </a>
            </td>
            <td>
              <a href="#" @click.prevent="redirectToDetails(true, 'totalAMEActive', false)">
                <span v-if="isLoading" class="spinner"></span>
                <span v-else>{{ totalAMEActive(false) }}</span>
              </a>
            </td>
            <td>
              <a href="#" @click.prevent="redirectToDetails(true, 'newInscriptions', false)">
                <span v-if="isLoading" class="spinner"></span>
                <span v-else>{{ newInscriptions(false) }}</span>
              </a>
            </td>
            <td>
              <a href="#" @click.prevent="redirectToDetails(false, 'labelings', false)">
                <span v-if="isLoading" class="spinner"></span>
                <span v-else>{{ labelings(false) }}</span>
              </a>
            </td>
            <td>
              <a href="#" @click.prevent="redirectToDetails(false, 'renewals', false)">
                <span v-if="isLoading" class="spinner"></span>
                <span v-else>{{ renewals(false) }}</span>
              </a>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent, PropType } from "vue"

export default defineComponent({
  name: "GraeListVueNational",
  props: {
    elements: {
      type: [Array, Object, Map] as PropType<Array<any> | Map<any, any>>,
      required: true,
    },
  },
  computed: {
    // Computed property to determine if data is loading
    isLoading(): boolean {
      return (
        !this.elements ||
        (Array.isArray(this.elements) && this.elements.length === 0) ||
        (this.elements instanceof Map && this.elements.size === 0)
      )
    },

    // Helper methods to get elements array
    elementsArray(): any[] {
      if (this.elements instanceof Map) {
        return Array.from(this.elements.values())
      } else if (Array.isArray(this.elements)) {
        return this.elements
      } else {
        return []
      }
    },

    // Computed properties for filtered elements
    schoolYearElements(): any[] {
      return this.elementsArray
        .filter((element) => this.isSchoolYear(element.anneeScolaire))
        .sort((a, b) => {
          // Extract the first year from format "YYYY-YYYY"
          return this.getEarliestYear(a.anneeScolaire, b.anneeScolaire)
        })
    },

    singleYearElements(): any[] {
      return this.elementsArray
        .filter((element) => this.isSingleYearMethod(element.anneeScolaire))
        .sort((a, b) => {
          return this.getEarliestYear(a.anneeScolaire, b.anneeScolaire)
        })
    },

    // Computed properties for school year and single year
    anneeScolaireSingleYear(): string {
      return this.singleYearElements.length > 0 ? this.singleYearElements[0].anneeScolaire : ""
    },

    anneeScolaireSchoolYear(): string {
      return this.schoolYearElements.length > 0 ? this.schoolYearElements[0].anneeScolaire : ""
    },

    anneeScolaireSingleYearInscription(): string {
      return this.singleYearElements.length > 0
        ? this.singleYearElements[0].anneeScolaireInscription
        : ""
    },

    anneeScolaireSchoolYearInscription(): string {
      return this.schoolYearElements.length > 0
        ? this.schoolYearElements[0].anneeScolaireInscription
        : ""
    },
  },
  methods: {
    parseScholarYear(anneeScolaire: string): number {
      // Extract the first year from format "YYYY-YYYY"
      return parseInt(anneeScolaire.split("-")[0], 10)
    },
    getEarliestYear(anneeScolaireA: string, anneeScolaireB: string): number {
      // return the earliest year from elements positive if a.year is after b.year
      return this.parseScholarYear(anneeScolaireA) - this.parseScholarYear(anneeScolaireB)
    },
    totalAEActive(isSingleYear: boolean): number {
      const elements = isSingleYear ? this.singleYearElements : this.schoolYearElements
      return elements.reduce(
        (count, element) => count + (element.nbAME || 0) + (element.nbATE || 0),
        0,
      )
    },

    totalATEActive(isSingleYear: boolean): number {
      const elements = isSingleYear ? this.singleYearElements : this.schoolYearElements
      return elements.reduce((count, element) => count + (element.nbATE || 0), 0)
    },

    totalAMEActive(isSingleYear: boolean): number {
      const elements = isSingleYear ? this.singleYearElements : this.schoolYearElements
      return elements.reduce((count, element) => count + (element.nbAME || 0), 0)
    },

    newInscriptions(isSingleYear: boolean): number {
      const elements = isSingleYear ? this.singleYearElements : this.schoolYearElements
      return elements.reduce((count, element) => count + (element.inscriptions || 0), 0)
    },

    labelings(isSingleYear: boolean): number {
      const elements = isSingleYear ? this.singleYearElements : this.schoolYearElements
      return elements.reduce(
        (count, element) => count + (element.labellisationsAccepteesCloturees || 0),
        0,
      )
    },

    renewals(isSingleYear: boolean): number {
      const elements = isSingleYear ? this.singleYearElements : this.schoolYearElements
      return elements.reduce(
        (count, element) => count + (element.renouvellementsAcceptesClotures || 0),
        0,
      )
    },

    // Utility methods to identify school year and single year
    isSchoolYear(anneeScolaire: string): boolean {
      return /\d{4}-\d{4}/.test(anneeScolaire)
    },

    isSingleYearMethod(anneeScolaire: string): boolean {
      return /^\d{4}$/.test(anneeScolaire)
    },

    // Method to handle redirection with appropriate filters
    redirectToDetails(isInscription: boolean, type: string, isSingleYear: boolean): void {
      let anneeScolaire = isSingleYear
        ? this.anneeScolaireSingleYear + "-" + this.anneeScolaireSingleYear
        : this.anneeScolaireSchoolYear
      if (isInscription) {
        anneeScolaire = isSingleYear
          ? this.anneeScolaireSingleYearInscription + "-" + this.anneeScolaireSingleYearInscription
          : this.anneeScolaireSchoolYearInscription
      }
      let filters: any[] = [
        { property: "anneeScolaire", values: [anneeScolaire] },
        { property: "projet.etat", values: ["ACTIF", "EN_COURS_DE_CREATION"] },
      ]

      switch (type) {
        case "totalATEActive":
          filters.push({ label: "Nature", property: "nature", values: ["ATE"] })
          break
        case "totalAMEActive":
          filters.push({ label: "Nature", property: "nature", values: ["AME"] })
          break
        case "newInscriptions":
          filters.push({ property: "inscriptionThisYear", values: ["true"] })
          break
        case "labelings":
          filters = [
            { label: "", property: "anneeScolaire", values: [anneeScolaire] },
            {
              label: "Stade du projet",
              property: "typeDossier",
              values: ["DOSSIER_LABELLISATION"],
            },
            {
              label: "Statut",
              property: "statut",
              values: ["LABELLISATION_EN_DEVENIR", "ACCEPTE"],
            },
          ]
          break
        case "renewals":
          filters = [
            { property: "anneeScolaire", values: [anneeScolaire] },
            {
              property: "typeDossier",
              values: ["DOSSIER_RENOUVELLEMENT_LIGHT", "DOSSIER_RENOUVELLEMENT"],
            },
            { label: "Statut", property: "statut", values: ["ACCEPTE"] },
          ]
          break
      }

      const encodedFilters = encodeURIComponent(JSON.stringify(filters))
      const url = `/ae/0?filters=${encodedFilters}`
      this.$router.push(url)
    },
  },
})
</script>

<style scoped>
table {
  border: solid 1px #dbdbdb;
  text-align: center;
  border-radius: 4px;
  margin-right: 10px;
  width: 100%;
  padding-right: 15px;
  border-collapse: separate;
}

.table thead {
  background: #fafafa !important;
}

th {
  border-bottom: solid 1px #dbdbdb;
  background-color: #fafafa !important;
}

td {
  padding: 5px;
}

h2 {
  color: #333;
  font-size: 20px;
}

h3 {
  color: #555;
  font-size: 17px;
}

.title {
  font-family: "Faune", sans-serif;
  font-weight: bold;
  color: #60b66b;
  text-decoration: underline;
}

.title2 {
  font-family: "Faune", sans-serif;
  font-weight: bold;
  color: black;
  text-decoration: underline;
}

a {
  color: #4a4a4a;
  font-size: 1em;
  font-weight: 400;
  line-height: 1.5;
}

/* Spinner styles */
.spinner {
  margin-left: 50%;
  display: flex;
  border: 3px solid rgba(96, 182, 107, 1);
  width: 24px;
  height: 24px;
  border-radius: 50%;
  border-left-color: #09f;
  animation: spin 1s ease infinite;
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
</style>
